export const ALERTS = {
  root: "alerts-page",
  saveBtn: "properties-save-search-btn",
  saveModal: "save-search-modal",
  saveModalName: "save-search-modal-name",
  saveModalCadence: "save-search-modal-cadence",
  saveModalSubmit: "save-search-modal-submit",
  saveModalCancel: "save-search-modal-cancel",
  navLink: "nav-alerts-link",
  emptyState: "alerts-empty-state",
  card: (id) => `alert-card-${id}`,
  deleteBtn: (id) => `alert-delete-${id}`,
  testBtn: "alerts-test-btn",
  statusBanner: "alerts-status-banner",
};
